import React, { VFC } from 'react';
import styled from 'styled-components';
import T from 'i18n-react';
import { useTheme, Theme } from '@material-ui/core/styles';
import LogoTextImage from '../../../../../images/logo-text.png';

const Img = styled.img<{ theme: Theme }>`
  width: 135px;
  height: auto;
  margin-right: ${({ theme }) => theme.spacing(2)};
  vertical-align: middle;
  border-style: none;
`;

interface Props {}
const PCLogo: VFC<Props> = (props: Props) => {
  const theme = useTheme();

  return (
    <Img
      src={LogoTextImage}
      alt={T.translate('otetsutabi') as string}
      theme={theme}
    />
  );
};

export default PCLogo;
